// Locks page scroll while the mobile menu drawer (or its submenus) is
// open, and restores it when closed. Plain overflow:hidden on body is
// not reliably enough on mobile Safari/Chrome (rubber-band scrolling
// can still move the page), so this fixes body in place at its current
// scroll position, then restores that exact position when unlocked.
document.addEventListener('DOMContentLoaded', function () {
  var drawerDetails = document.getElementById('Details-menu-drawer-container');
  if (!drawerDetails) return;

  var savedScrollY = 0;
  var isLocked = false;

  function lockScroll() {
    if (isLocked) return;
    isLocked = true;
    savedScrollY = window.scrollY || window.pageYOffset;
    // Only position + top are set. Deliberately NOT setting
    // left/right/width here - those combined with the drawer's own
    // width:100% sizing caused horizontal overflow on mobile.
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + savedScrollY + 'px';
    document.body.classList.add('custom-drawer-open');
  }

  function unlockScroll() {
    if (!isLocked) return;
    isLocked = false;
    document.body.classList.remove('custom-drawer-open');
    document.body.style.position = '';
    document.body.style.top = '';
    window.scrollTo(0, savedScrollY);
  }

  function updateScrollLock() {
    if (drawerDetails.hasAttribute('open')) {
      lockScroll();
    } else {
      unlockScroll();
    }
  }

  drawerDetails.addEventListener('toggle', updateScrollLock);

  // Fallback in case Dawn's own JS closes the drawer in a way that
  // doesn't reliably fire a 'toggle' event in every browser.
  var checkInterval = setInterval(updateScrollLock, 300);

  window.addEventListener('beforeunload', function () {
    clearInterval(checkInterval);
  });
});